import React, { useContext, useEffect, useState } from 'react'
import { path, split, __, pipe } from 'ramda'
import { object, node, string } from 'prop-types'
import localeContext from './Locale'

const moduleTranslationContext = React.createContext()
const { Provider } = moduleTranslationContext

export const ModuleTranslationProvider = ({ translations, children, module }) => {
  const locale = useContext(localeContext)
  const [translationsByLang, setTranslationsByLang] = useState(null)

  useEffect(() => {
    const initTranslations = async () => {
      try {
        const transLoader = translations[locale.lang]
        if (typeof transLoader === 'function') {
          setTranslationsByLang(await transLoader())
        } else {
          setTranslationsByLang(transLoader)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Error loading module translations - ${module}`, error)
      }
    }
    initTranslations()
  }, [])

  if (!translationsByLang) {
    return null
  }
  const translate = (p) => {
    return pipe(split('.'), path(__, translationsByLang))(p)
  }

  return <Provider value={translate}>{children}</Provider>
}

ModuleTranslationProvider.propTypes = {
  translations: object.isRequired,
  children: node.isRequired,
  module: string.isRequired
}

export default moduleTranslationContext
